import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zaiks-report',
  templateUrl: './zaiks-report.component.html',
  styleUrls: ['./zaiks-report.component.scss']
})
export class ZaiksReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
